<!-- Button -->
<button mat-menu-item [matMenuTriggerFor]="languages">
    <span class="flex items-center">
        <ng-container
            *ngTemplateOutlet="
                flagAbbreviation;
                context: { $implicit: activeLang }
            "
        ></ng-container>
        <span class="ml-4">{{ "Language" | transloco }}</span>
    </span>
</button>

<!-- Language menu -->
<mat-menu [xPosition]="'before'" #languages="matMenu">
    @for (lang of availableLangs; track trackByFn($index, lang)) {
        <button mat-menu-item (click)="setActiveLang(lang.id)">
            <span class="flex items-center">
                <ng-container
                    *ngTemplateOutlet="
                        flagAbbreviation;
                        context: { $implicit: lang.id }
                    "
                ></ng-container>
                <span class="ml-4">{{ lang.label }}</span>
            </span>
        </button>
    }
</mat-menu>

<!-- Flag abreviated template -->
<ng-template let-lang #flagAbbreviation>
    <span class="relative w-6 overflow-hidden rounded-sm shadow text-center">
        <span
            class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"
        ></span>
        <span class="text-md font-medium">
            {{ flagCodes[lang].toUpperCase() }}
        </span>
    </span>
</ng-template>
